/*---[ ESLint ]---*/
/*
    global capcodes
*/


import { ModuleActionViewEnum } from '../enums/moduleActionViewEnum'

import * as appsettings from '../appsettings';
import * as dialog from '../dialog';
import * as main from '../main';
import * as navigation from '../navigation';
import * as viewmode from '../viewmode';


export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // dataItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as CapcodeGridVM;

    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Capcodes/Show?capcode=" + dataItem.Capcode + "&breadcrumbLabel=" + encodeURIComponent(dataItem.Capcode));
}


export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // dataItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as CapcodeGridVM;

    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Capcodes/Edit?capcode=" + dataItem.Capcode + "&breadcrumbLabel=" + encodeURIComponent(dataItem.Capcode));
}


export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid) {
        // Prevent default behaviour
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as CapcodeGridVM;
        deleteCapcode(dataItem.Capcode);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}


export function deleteCapcode(capcode: number): void {

    $.ajax({
        type: "GET",
        url: appsettings.getUrl("Capcodes/DeleteCapcode?capcode=" + capcode),
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            navigation.navigateToSpecificUrl("Capcodes/Overview");
        }
    });

}


